import React, { useEffect, useState } from 'react';
import GridColumns from './GridColumns';

export interface ResponsiveTemplates {
    desktop?: string;
    tablet?: string;
    notebook?: string;
    mobile?: string;
}

interface ResponsiveGridProps {
    templates: ResponsiveTemplates;
    breakpoints?: { tablet?: number; desktop?: number, notebook?: number };
    children?: React.ReactNode;
    className?: string;
    styles?: React.CSSProperties;
    gridReverse?: boolean;
}

const ResponsiveGrid: React.FC<ResponsiveGridProps> = ({
    templates,
    breakpoints = { tablet: 768, notebook: 1280, desktop: 1920 },
    children,
    className,
    styles,
    gridReverse = false,
}) => {
    const [size, setSize] = useState<string>(templates.desktop || '1fr');

    useEffect(() => {
        const update = () => {
            const w = window.innerWidth;
            if (w >= (breakpoints.desktop ?? 10000)) {
                setSize(templates.desktop ?? templates.tablet ?? templates.mobile ?? '1fr');
            } else if (w >= (breakpoints.notebook ?? 1280)) {
                setSize(templates.notebook ?? templates.tablet ?? templates.mobile ?? '1fr');
            } else if (w >= (breakpoints.tablet ?? 768)) {
                setSize(templates.tablet ?? templates.mobile ?? templates.desktop ?? '1fr');
            } else if (w >= (breakpoints.tablet ?? 768)) {
                setSize(templates.tablet ?? templates.mobile ?? templates.desktop ?? '1fr');
            } else {
                setSize(templates.mobile ?? templates.tablet ?? templates.desktop ?? '1fr');
            }
        };

        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, [templates, breakpoints]);

    return (
        <GridColumns size={size} className={className} styles={styles} gridReverse={gridReverse}>
            {children}
        </GridColumns>
    );
};

export default ResponsiveGrid;
